import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SubscriptionLimitations  {
    _originalTypeClassName = "zAppDevManager.BO.SubscriptionLimitations";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SubscriptionLimitations.translate = translateService;
}
this.Id = null;
this.CanCreateEnvironment = false;
this.MaxModels = null;
this.MaxUsers = null;
this.MaxApplications = null;
this.MaxBuildTimePerHour = null;
this.MaxStorageCapacity = null;
this.MaxDBCapacity = null;
this.CanDownloadSolution = false;
this.CanDebug = false;
this.CanGenerateDocumentation = false;
this.AIServices = false;
this.CanUploadModels = false;
this.CanDownloadModels = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
CanCreateEnvironment:any;
MaxModels:any;
MaxUsers:any;
MaxApplications:any;
MaxBuildTimePerHour:any;
MaxStorageCapacity:any;
MaxDBCapacity:any;
CanDownloadSolution:any;
CanDebug:any;
CanGenerateDocumentation:any;
AIServices:any;
CanUploadModels:any;
CanDownloadModels:any;


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}